import { styled, media } from '@creditas-ui/react'

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 60%;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 92px;
  height: 15vh;
  z-index: 100;
  padding: 0 36px;

  ${media.up('7xl')} {
    min-height: 192px;
    height: 25vh;
    padding: 0 36px;
  }
`

export { Footer }
